
export const Work = [
    {
      id:1,
      name:"StarConnect",
      description:"StarConnect: The project was developed during Dappathon Season 2, marking the beginning of our journey into the world of Web3 technology built to revolutionize personalized content creation and combating deep fake proliferation with NFTs",
      tags:[],
      img:"https://media.giphy.com/media/Ak4ny9H3nr1kntLwR5/giphy.gif",
      demo:"https://www.youtube.com/watch?v=0bgOH1sXGos",
      github:"https://github.com/J4Web/starConnect"
    },
    // {
    //   id:2,
    //   name:"BuildNft.ai",
    //   description:"",
    //   tags:[],
    //   img:"",
    //   demo:"",
    //   github:""
  
    // },
    {
      id:2,
      name:"CryptoHunter",
      description:"Crypto Hunter: is a user-friendly cryptocurrency tracking website designed for crypto enthusiasts and investors. With Crypto Hunter, you can easily access up-to-date information about various cryptocurrencies, including popular options like Bitcoin (BTC) and Ethereum (ETH).",
      tage:[""],
      img:"https://media.giphy.com/media/hMkmeNiDoQlJ83IjlG/giphy.gif",
      demo:"https://crypto-hunter.netlify.app/",
      github:"https://github.com/J4Web/crypto-hunter"
  
    },
      {
          id:3,
          name:"ReactColorPicker",
          description:" React Colors: Your go-to web app for creating and managing color palettes. Ideal for designers and developers with powerful customization features. Simplify your color work today!",
          tags:["react","ether.js","tailwind"],
          img:"https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExbHlnOXlmbDNibjI1aHNqdG0xMWQ2aWlqOGdwZHFpYTJsZ2U4bjk2aiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/aT8TNSL3TiSFvg4qm2/giphy.gif",
          demo:"https://reactcolorpicker.netlify.app/",
          github:"https://github.com/J4Web/ColorPicker"
      },
      {
        id:4,
        name:"Quiz-Appy",
        description:"Quiz-Appy is a programming quiz game that draws inspiration from the popular game Wordle. This project stands as a testament to rapid development, as it was created in just three days for both a web and a mobile.",
        tags:[],
        img:"https://media.giphy.com/media/KxXoAIMau6lqQ1IGzw/giphy.gif",
        demo:"https://quiz-appy.netlify.app/",
        github:"https://github.com/J4Web/quiz-app",
      },
      {
        id:5,
        name:"DigifyCraft",
        description:"DigifyCraft is a mock digital website designed to help its clients in the digital landscape. In an era where online presence is crucial for success, DigifyCraft stands as a virtual partner dedicated to helping customers!",
        tags:"",
        img:"https://media.giphy.com/media/EK3amL8S3olQYm5IoT/giphy.gif",
        demo:"https://digifycraft.netlify.app/",
        github:"https://github.com/J4Web/DigifyCraft"
   
      },{
        id:6,
        name:"LightsOut",
        description:"LightsOut is a delightful and brain-teasing game that will test your puzzle-solving prowess. In this captivating challenge, your mission is clear: turn off all the lights. But can you master the art of darkness?",
        tags:[],
        img:"https://media.giphy.com/media/hRpupGhwwKOLcSol1o/giphy.gif",
        demo:"https://lights-gone.netlify.app/",
        github:"https://github.com/J4Web/lightsOut-Game "
      }
  ] 